"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const react_1 = __importDefault(require("react"));
const oxygen_config_1 = require("@8x8/oxygen-config");
const oxygen_tooltip_1 = __importStar(require("@8x8/oxygen-tooltip"));
const oxygen_button_1 = require("@8x8/oxygen-button");
const InfoCircleIcon_1 = __importDefault(require("@8x8/oxygen-icon/icons/InfoCircleIcon"));
const InfoCircleIcon_2 = __importDefault(require("@8x8/oxygen-icon/novo/InfoCircleIcon"));
const Icon = (props) => {
    const propsWithDefault = {
        testId: 'LABEL',
        ...props,
    };
    const { theme, testId, infoBoxText, infoBoxShowOn, infoBoxButtonLabel } = propsWithDefault;
    const InfoIcon = theme.iconSet === 'novo' ? InfoCircleIcon_2.default : InfoCircleIcon_1.default;
    const iconButtonProps = {
        ...(infoBoxButtonLabel && { 'aria-label': infoBoxButtonLabel }),
    };
    return (react_1.default.createElement(oxygen_tooltip_1.default, { title: infoBoxText, orientation: oxygen_tooltip_1.orientation.top, showOn: infoBoxShowOn, includeWrapper: false },
        react_1.default.createElement(oxygen_button_1.IconButton, { ...iconButtonProps },
            react_1.default.createElement(InfoIcon, { ...(0, oxygen_config_1.getTestAttributes)(`${testId}_ICON`), color: theme.iconColor, size: theme.iconSize }))));
};
exports.Icon = Icon;
exports.default = exports.Icon;
